import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col gap-[32px]',
    title: 'heading-2xl lg:heading-3xl leading-[120%] font-semibold',
    subtitle: 'lg:text-m font-regular trading-[0,02] text-xs leading-[140%]',
    informer:
      'text-s pointer-events-auto! translate-y-0! cursor-pointer! leading-[140%] font-semibold text-black opacity-100!',
    form: 'flex flex-col gap-[32px]',
    fields: 'flex flex-col gap-6',
    row: 'flex items-center justify-between',
    button: 'mt-[32px] w-full lg:mt-0',
    forgotPassword: 'heading-xs-bold h-auto cursor-pointer p-0 normal-case',
    loginBySMS:
      'heading-xs trading-[0,06] mt-4 h-6 border-0 p-0 leading-[120%] font-semibold text-black uppercase hover:translate-x-0 hover:border-0 hover:text-black',
    arrowIcon: '',
    iconWrapper:
      'ml-[12px] flex h-[24px] w-[24px] items-center justify-center rounded-full border',
    backButtonWrapper: 'mt-[8px] mb-[18px]',
    backButton: '[&>span>span]:text-regular h-auto! p-0!'
  },
  variants: {
    color: {
      primary: 'text-black'
    },
    informerState: {
      hidden: {
        informer: 'pointer-events-none -translate-y-100 opacity-0'
      },
      visible: {
        informer: 'translate-y-0 opacity-100'
      }
    }
  },
  defaultVariants: {
    color: 'primary',
    informerState: 'hidden'
  }
});
